import React from "react";
import { FiBell, FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import '../AdminNotifications.css'

const Notifications = ({
    title = "Notifications",
    notifications = [],
    onMarkAllAsRead,
    onMarkAsRead
}) => {   const navigate = useNavigate();
    return (
        <div className="notifications-page">
            <div className="notifications-header">
                <IconButton 
                onClick={() => navigate(-1)}
                    sx={{
                        background: 'linear-gradient(135deg, #00bcd4, #007bff)',
                        color: '#fff',
                        '&:hover': { transform: 'scale(1.1)' },
                        borderRadius: '12px',
                        padding: {
                            xs: '6px 8px',
                            sm: '8px 10px',
                            md: '8px 12px'
                        },
                        mr: {
                            xs: 1,
                            sm: 2
                        },
                        fontSize: {
                            xs: '1rem',
                            sm: '1.2rem'
                        }
                    }}
                >
               <FiArrowLeft />
                </IconButton>
                    
                    <div className="notification-title">
                        <FiBell className="notification-icon" />
                        <span className="title-text"> {title} </span>
                    </div>
                
                <button className="mark-all-button" onClick={onMarkAllAsRead}>
                    Mark All as Read
                </button>
            </div>


            <div className="notifications-list">
                {/* {notifications.map(notif => (
          <div
            key={notif.id}
            className={`notification-item ${notif.read ? '' : 'unread'}`}
          >
            <div className="notification-icon">{notif.icon}</div>
            <div className="notification-details">
              <p>{notif.message}</p>
              <span className="time">{notif.time}</span>
            </div>
            {!notif.read && (
              <button
                className="mark-read-btn"
                onClick={() => onMarkAsRead(notif.id)}
              >
                Mark as Read
              </button>
            )}
          </div>
        ))} */}


                {notifications.map(notif => (
                    <div
                        key={notif.id}
                        className={`notification-item ${notif.read ? '' : 'unread'} ${notif.type}-notif`}
                    >
                        <div className={`notification-icon ${notif.type}-icon`}>{notif.icon}</div>
                        <div className="notification-details">
                            <p>{notif.message}</p>
                            <span className="time">{notif.time}</span>
                        </div>
                        {!notif.read && (
                            <button
                                className="mark-read-btn"
                                onClick={() => onMarkAsRead(notif.id)}
                            >
                                Mark as Read
                            </button>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Notifications;
